const state = () => ({
    fileState : {},
    test : null,
    effectImageObject : null,
    effects : null,
    assetsAniamtions : []
})

export default state;


// WEBPACK FOOTER //
// ./src/store/assets/state.js